import { Upload } from 'antd'

import Camera from '../../svgs/Camera2'

const UploadCard2 = ({ title, subTitle, onChange, imageUrl }) => {
  return (
    <Upload
      className='upload-card'
      maxCount={1}
      onChange={onChange}
      beforeUpload={() => false}
    >
      <div className='bg-green_50 border border-green_300 rounded-xl py-24 xl:py-48 px-20 text-center lg:max-w-full mx-auto'>
        <div
          className='bg-cover bg-center bg-no-repeat w-[9.25rem] h-[9.25rem] mx-auto rounded-full mb-30 relative'
          style={{ backgroundImage: `url(${imageUrl})` }}
        >
          <div className='w-40 h-40 bg-white rounded-full absolute left-1/2 bottom-0 -translate-x-1/2 translate-y-1/2 shadow-icon flex items-center justify-center'>
            <Camera style='w-24' />
          </div>
        </div>
        <h5 className='text-green text-base font-semibold mb-8'>{title}</h5>
        <p className='text-[#6D6D6D] text-xs leading-5'>{subTitle}</p>
      </div>
    </Upload>
  )
}

export default UploadCard2
